document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const passedSize = urlParams.get('view_size');

    if (window.location.search.includes('variant=') && !passedSize) return;

    const targetSizeName = passedSize ? passedSize.toUpperCase() : 'L';
    
    const targetNumericSizes = passedSize ? [passedSize] : ['34', '33-36']; 

    const sizeOptionKeywords = ['size'];

    const optionContainers = document.querySelectorAll('.ProductForm__Option, .ProductForm__Item');

    optionContainers.forEach(container => {
        const labelElement = container.querySelector('.ProductForm__Label, label');
        if (!labelElement) return;

        const isSizeOption = sizeOptionKeywords.some(keyword => 
            labelElement.textContent.toLowerCase().includes(keyword)
        );
        if (!isSizeOption) return;

        const allRadioInputs = Array.from(container.querySelectorAll('input[type="radio"]'));
        
        if (allRadioInputs.length > 0) {
            const availableRadioInputs = allRadioInputs.filter(input => {
                const isUnavailable = input.parentElement.classList.contains('Unavailable');
                return !isUnavailable && !input.disabled;
            });

            if (availableRadioInputs.length === 0) return;

            let targetInput = availableRadioInputs.find(input => {
                const val = input.value.trim().toUpperCase();
                return val === targetSizeName || val.endsWith(' ' + targetSizeName) || val.endsWith('-' + targetSizeName);
            });

            if (!targetInput) {
                targetInput = availableRadioInputs.find(input => {
                    const val = input.value.trim().toUpperCase();
                    return val.includes(targetSizeName + '-') || val.includes('-' + targetSizeName);
                });
            }

            if (!targetInput) {
                for (const prioritySize of targetNumericSizes) {
                    targetInput = availableRadioInputs.find(input => {
                        const val = input.value.trim();
                        return val === prioritySize || val.split('-').includes(prioritySize);
                    });
                    if (targetInput) break;
                }
            }

            if (!targetInput) {
                const preferredSizeIndex = allRadioInputs.findIndex(input => 
                    input.value.toUpperCase().includes(targetSizeName)
                );

                if (preferredSizeIndex !== -1) {
                    const availableBeforePreferred = availableRadioInputs.filter(input => 
                        allRadioInputs.indexOf(input) < preferredSizeIndex
                    );
                    targetInput = availableBeforePreferred[availableBeforePreferred.length - 1];
                }
            }

            if (!targetInput) {
                targetInput = availableRadioInputs[0];
            }

            if (targetInput && !targetInput.checked) {
                setTimeout(() => {
                    targetInput.click();
                }, 50);
            }
        } else {
            const selectElement = container.querySelector('select');
            if (selectElement) {
                const availableOptions = Array.from(selectElement.options).filter(option => !option.disabled);
                
                let foundOption = null;
                for (const pSize of targetNumericSizes) {
                    foundOption = availableOptions.find(o => o.value.trim() === pSize || o.value.split('-').includes(pSize));
                    if (foundOption) break;
                }

                const targetOption = availableOptions.find(o => o.value.trim().toUpperCase() === targetSizeName) || foundOption || availableOptions[0];
                
                if (targetOption && selectElement.value !== targetOption.value) {
                    setTimeout(() => {
                        selectElement.value = targetOption.value;
                        selectElement.dispatchEvent(new Event('change', { bubbles: true }));
                    }, 50);
                }
            }
        }
    });
});